import React from "react";
import { useEffect } from "react";

import { MapType } from "../../../../types/dataTypes";
import { mapGetLayerExists, mapCorrectLayerOrder, mapGetSourceExists } from "../../../../utils/mapDataHandler";
import { LAYER_ORDER_ARRAY } from "../../../../utils/mapConsts";
import { COLORS_BASE } from "../../../../utils/consts";
import { getGeoJsonByName } from "../../../../services/getGeojsonData.service";
import { isConditionalExpression } from "typescript";

type CircleLayerProps = {
  map: MapType;
  mapLoaded: boolean;
  layerId: string;
  geojsonName: string;
  color: string |undefined;
  borderColor: string |undefined;
  lineWeight: number;
};

function CircleLayer({ map, mapLoaded, geojsonName, layerId, color, lineWeight = 3, borderColor}: CircleLayerProps) {
  const mapCurrent = map.current;

  useEffect(() => {
    if (!mapLoaded || !mapCurrent) return;
    const isMobile = typeof window !== 'undefined' && window.matchMedia('(max-width: 768px)').matches;
    getGeoJsonByName(geojsonName).then((res) => {
      if (res.statusCode === 500) {
        console.error("500 Error: data not available");
      } else {
        // setGovData(res);
        if(mapGetSourceExists(mapCurrent, layerId) || mapGetLayerExists(mapCurrent, layerId)){return}
        // mapRemoveLayerSource(mapCurrent, [NARAWA_GABES_PIPELINE]);
        mapCurrent.addSource(layerId, {
          type: "geojson",
          data: res,
        });
        mapCurrent.addLayer({
          id: layerId,
          type: "circle",
          source: layerId,
          layout: { visibility: "visible" },
          paint: {
            "circle-radius": isMobile ? 7 : 4,
            "circle-color": color?color:COLORS_BASE.BRAND.MAIN,
            "circle-stroke-color": borderColor?borderColor:'white',
            "circle-stroke-width": lineWeight,
            },
        });
        //add line type if exists in the layer definition        
        mapCorrectLayerOrder(mapCurrent, LAYER_ORDER_ARRAY)
      }
    });
  },);



  return null;
}

export default CircleLayer;